StepFunctions = App.loadClass 'grower::classes/placement/StepFunctions'
StepTransition = App.loadClass 'grower::classes/placement/StepTransition'

class exports.SppHandler extends FullPageHandler

    constructor: () ->
        super()

        @useMessageWriter = true
        @inputChanged = false

        # Define generic step functions in StepFunctions.coffee.
        # The StepFunctions object is simply a wrapper for these functions.
        @stepFunctions = new StepFunctions()

        # @customStepFunctions should be overridden in the init function of the
        # SppHandler subclass, and should follow the following structure:
        #
        # @customStepFunctions =
        #     step_1:
        #             afterEnter: @stepFunctions.testFunc
        #             beforeLeave: (step) =>
        #                 alert 'So long, sucka!'
        #                 return true
        #         step_2:
        #             skipConditions: (step) =>
        #                 alert 'I\'ma firin my lazorz!'
        #                 return false
        #
        @customStepFunctions = {}

        # @customButton is used for creating custom buttons, etc in the sidebar
        @customButton = null

        # @customButtonFn is a function that can be run to intialize the contents
        # of @customButton
        @customButtonFn = () -> return


    init: () ->

        @loadLayoutPostOptions =
            id: @sppID
        @loadLayoutPostOptions.result_id = @resultID if @resultID?

        @layoutUrl = 'backend/grower/placement/spp/load-layout'

        @createDialog()
        @openDialog()
        @displayLoadingMessage('Please wait...<br>' +
            'Loading field data, product details, and personalized crop management questions...'
        )


    afterLoadLayout: (selector, response) ->
        if response?.status?.type  isnt 'success'
            return

        data = response.data

        @importSteps()

        @companyID = data.company_id
        @cropID = data.crops_id
        @cropName = data.crop_name
        @year = +data.year
        @resultID = data.result_id
        @finished = data.finished
        @popWeightings = data.population_weightings
        @rowSpacings = data.row_spacings
        @operators_id = data.operators_id ? null
        @operator_name = data.operator_name ? null

        @enable_rx_plans = data.enable_rx_plans
        @makes_recommendations = data.makes_recommendations
        @calculates_populations = data.calculates_populations

        @numVisibleResults = data.number_of_visible_hybrid_results

        stepNum = data.step_num

        # If we are going directly to the final step, currentFieldID will be
        # used once to go to the current field, then deleted. This way if the
        # user goes back to into the survey, they will start at the first field
        # again when they return to the final step.
        if stepNum is @taffyObjects.steps().count()
            @currentFieldID = data.fields_id

        @parent.afterSurveyLoaded(this)

        # load the initial step
        @goToStep(stepNum)


    goToStep: (stepNum, fromNav = false) ->
        if not @curTransition
            @curTransition = new StepTransition(@curStep or this, stepNum, fromNav)


    importSteps: () ->
        valid_step_functions = [
            'afterEnter'
            'beforeLeave'
            'skipConditions'
        ]

        # initialize the steps
        @subHandlers = []
        @taffyObjects.steps().each (step) =>
            key = "step_#{step.step_order}"

            # configure subhandlers
            handler_name = step.widget_name.replace(/_/g, '') + 'Handler'
            @subHandlers[key] =
                class: "grower::handlers/placement/widgets/#{handler_name}"
                attrs:
                    id: step.id
                    num: step.step_order

            # add custom step functions
            if @customStepFunctions[key]?
                for k, fn of @customStepFunctions[key]
                    if k in valid_step_functions
                        step[k] = fn

            # set the @parent attribute
            step.parent = this

        # exclude FStF because it doesn't really count as a step to the user
        @has_multiple_steps = @taffyObjects.steps(widget_name: '!is': 'Seed_Options').count() > 1

    getHighestVisitedStep: () ->
        num = 0
        @taffyObjects.steps().each (step) =>
            if step.visited() and step.step_order > num
                num = step.step_order
        return num


    getFieldAspectByName: (field_id, aspect_name) ->
        aspect = @taffyObjects.fieldsAspects
            fields_id: field_id
            aspect_name: aspect_name
        .first()
        return aspect


    finish: (callback) ->
        callback ?=  () -> return
        @finished = true
        $('#reset_survey_button').addClass('btn-primary')

        # mark the result as finished
        postOptions =
            id: @sppID
            result_id: @resultID
        $.post 'backend/grower/placement/spp/finish-survey', postOptions, (response) =>
            # yay, we did it!
            callback(response)


    destroy: () ->
        $('.spp-step-list').hide()
        super()


    customPlantingPlan: (field_id, plan, notes_obj) -> return # this is a stub

    # simple wrapper to provide access to the planter subscription, which isn't
    # actually defined until customPlantingPlan() is called. "event" is an
    # instance of the Event model.
    customPlanterSubscription: (event, planter_id) =>
        @_customPlanterSubscription?(event, planter_id)

    # simple wrapper to provide access to the population adjustment, which
    # isn't defined until customPlantingPlan() is called (or not at all).
    # "event" is the Event model for the event that we're calculating a
    # population for. Returns the adjusted population value.
    customPopulationAdjustment: (event, population) =>
        return @_customPopulationAdjustment?(event, population) ? null

    # simple wrapper to provide access to the product subscription, which isn't
    # actually defined until customPlantingPlan() is called. "stage" is an
    # instance of the Stage model.
    customProductSubscription: (stage, product_id) =>
        @_customProductSubscription?(stage, product_id)


    # TODO: "actionPdf" is a terrible name. Plz change it in angular 2.
    actionPdf: (layer_ids, long_pdf = false, disable_extra_button = false) =>
        button_id = '#pdf_button'
        @disableButton(button_id, not long_pdf)
        @disableButton(disable_extra_button, long_pdf) if disable_extra_button

        params =
            id: @sppID
            result_id: @resultID
            layer_ids: layer_ids
            send_email: true
            long_pdf: long_pdf

        $.post 'backend/grower/placement/spp/generate-psr', params, (response) =>
            if response?.status?.type is 'success'
                # pdf should have been generated at this point
                # attempt to display it
                @showPsr(response, button_id)
            else
                @handleError(response, button_id, 'placement report')

            @enableButton(disable_extra_button) if disable_extra_button

    showPsr: (response, button_id) =>
        try
            params = $.param
                file: response.data.file
                file_name: response.data.file_name
            window.open("backend/grower/placement/report/show-psr?#{params}")
            @enableButton(button_id)
        catch e
            # data probably undefined; don't really care
            @enableButton(button_id)
            throw e


    generatePalletTags: (layer_ids, button_id) =>
        @disableButton(button_id)

        params =
            id: @sppID
            layer_ids: layer_ids
        $.post('backend/grower/placement/pallet-tags/create', params).done (response) =>
            if response.file and response.file_name
                @showPalletTags(response, button_id)
            else
                @handleError(response, button_id, 'pallet tags')
        .fail (response) =>
            @handleError(response, button_id, 'pallet tags')

    showPalletTags: (response, button_id) =>
        try
            paramStr = $.param
                file: response.file
                file_name: response.file_name
            window.open("backend/grower/placement/pallet-tags/get?#{paramStr}")
            @enableButton(button_id)
        catch e
            # data probably undefined; don't really care
            @enableButton(button_id)
            throw e


    # TODO: in ng2, change the button state stuff to use promises
    enableButton: (button_id) =>
        $(button_id).button('reset')

    disableButton: (button_id, is_processing = true) =>
        $(button_id).button('loading') if is_processing
        $(button_id).prop("disabled", true) if not is_processing

    handleError: (response, button_id, thing) =>
        # something went wrong, display error and reset button
        sub = 'grower::handlers/placement/widgets/SeedOptionsHandler'
        default_msg = "Failed to generate #{thing}. Please contact MyFarms Support for assistance."
        @activeSubHandlers[sub]?.msg.message_writer(
            response?.status?.type ? 'error'
            response?.status?.msg ? default_msg
            true
        )
        @enableButton(button_id)
